module.exports = __webpack_public_path__ + "img/logo.c1af5039.png";